export enum FormFields {
  Phone = 'phone',
}

export interface FormValues {
  [FormFields.Phone]?: string;
}
